import template from './confirmCloseModal.html';
import controller from './confirmCloseModal.controller';
import './confirmCloseModal.scss';

let confirmCloseModalComponent = {
  restrict: 'E',
  bindings: {
    description: '@',
    smallDescription: '@',
    buttonYes: '<',
    literalLoansConfirmation: '@',
    onConfirm: '&',
    buttonNo: '<',
    onClickNo: '&',
    titleModal: '@',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default confirmCloseModalComponent;



// WEBPACK FOOTER //
// ./client/app/components/confirmCloseModal/confirmCloseModal.component.js